module.exports = __webpack_public_path__ + "static/Portfolio11-ff9e3f66872fa26c0a0d3ca3c1277f32.jpg";